class Getter {
    constructor() {

    }

    /*
        examples

            const data = {
                a: {
                    aa: 1
                    ab: 2
                }
            }

            getter.safeGet((data) => data.a.ab, "asdf"); // returns 1
            getter.safeGet((data) => data.a.something, "asdf"); // returns "asdf"
    */
    safeGet = (getFunc, fallbackValue) => {
        try {
            const result = getFunc();
            if (typeof result !== "undefined") return result;
            return fallbackValue;
        } catch (error) {
            return fallbackValue;
        }
    }
}

export default Getter;